import React from 'react'
import { Link } from 'react-router-dom';
import logo from '../../media/logo.png';
import config from '../../config';


export default function Logo() {
    const handleToggleSidebar = () => {
        document.body.classList.toggle('toggle-sidebar');
    }
    return (
        <>
            <div className='d-flex align-items-center justify-content-between'>
                <Link to='#' className='logo d-flex align-items-center'>
                    {/*
                    <span className='d-none d-lg-block'> Oonovoo Admin </span>
                    */}
                    <img src={`${config.logo}`} alt="Admin Logo" style={{borderRadius: "10px"}} />
                </Link>
                <i className='bi bi-list toggle-sidebar-btn' onClick={handleToggleSidebar}>

                </i>
            </div>
        </>
    )
}